import { RangeOperationDialog } from '@/components/edit/range-operation-dialog'

export interface InterpolateGpsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

/** Replaces GPS in the chosen range with a straight-line interpolation between the nearest good points on either side. */
export function InterpolateGpsDialog({ open, onOpenChange }: InterpolateGpsDialogProps) {
  return (
    <RangeOperationDialog
      open={open}
      onOpenChange={onOpenChange}
      idPrefix="interpolate-gps"
      title="Interpolate GPS"
      description="Replaces GPS in this range with a straight-line interpolation between the nearest valid points before and after it. Requires a valid position on both sides of the range."
      confirmLabel="Interpolate GPS"
      buildOperation={(start, end) => ({ type: 'interpolateGps', start, end })}
    />
  )
}
